<template>
  <page-layout title="Balises NEYOS">
    <template v-slot:breadcrumb>
      <li><router-link :to="{ name: 'home' }">Dashboard</router-link></li>
      <li class="is-active"><a href="#">Balises NEYOS</a></li>
    </template>
    <list-neyos-trackers-filter />
    <list-neyos-trackers-table :neyosTrackers="neyosTrackers" :loading="loading" class="box" />
  </page-layout>
</template>

<script>
import PageLayout from '@components/PageLayout.vue'
import ListNeyosTrackersTable from './ListNeyosTrackersTable.vue'
import ListNeyosTrackersFilter from './ListNeyosTrackersFilter.vue'
import { mapActions } from 'vuex'

export default {
  name: 'ListNeyosTrackersPage',

  components: {
    PageLayout,
    ListNeyosTrackersTable,
    ListNeyosTrackersFilter,
  },

  data() {
    return {
      loading: false,
      neyosTrackers: [],
    }
  },

  async beforeRouteUpdate(to, from, next) {
    await this.load(to.query)

    next()
  },

  async mounted() {
    await this.load(this.$route.query)
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async load(routeQuery) {
      const filters = this.buildFiltersObject(routeQuery)

      this.loading = true

      await this.fetchNeyosTrackers(filters)
      await this.fetchLastNeyosTrackersLocation(filters)

      this.loading = false
    },

    buildFiltersObject(routeQuery) {
      return {
        keyword: routeQuery?.keyword ?? null,
        availability: routeQuery?.availability ?? null,
        owner: routeQuery?.owner ?? null,
        wear: routeQuery?.wear ?? null,
      }
    },

    async fetchNeyosTrackers(filters) {
      try {
        this.neyosTrackers = await this.$services.neyosTrackerService.getAll(filters)
      } catch (err) {
        this.neyosTrackers = []
        this.addToastMessage({
          text: 'Impossible de charger les balises NEYOS.',
          type: 'is-danger',
        })
        console.error(err)
      }
    },

    async fetchLastNeyosTrackersLocation(filters) {
      try {
        const latestLocations =
          await this.$services.neyosTrackerLocationService.getLatestLocationByNeyosTrackersFilters(
            filters,
          )

        const locationsMap = new Map(
          latestLocations.map((location) => [location.neyosTrackerId, location]),
        )

        this.neyosTrackers = this.neyosTrackers.map((tracker) => {
          const location = locationsMap.get(tracker.id)
          return {
            ...tracker,
            locatedAt: location?.locatedAt,
            batteryPercentage: location?.batteryPercentage,
          }
        })
      } catch (err) {
        this.addToastMessage({
          text: "Les dernières positions n'ont pas pu être chargées.",
          type: 'is-warning',
        })
        console.error(err)
      }
    },
  },
}
</script>
